import { createMuiTheme } from "@material-ui/core/styles";
import deepmerge from 'deepmerge';

const helperThemeOptions = {
    typography: {
        useNextVariants: true,
    },
    palette: {
        type: 'light',
        primary: {
            main: '#4a90e2'
        },
        success: {
            light: '#81c784',
            main: '#5E9B09',
            dark: '#388e3c',
            contrastText: 'rgba(0, 0, 0, 0.87)'
        }
    }
};

export const basic = createMuiTheme(helperThemeOptions);

export default createMuiTheme(deepmerge(helperThemeOptions, {

    overrides: {
        MuiCssBaseline: {
            '@global': {
                html: {
                    backgroundColor: basic.palette.common.black
                }
            }
        },
        // MuiTypography: {
        //     root: {
        //         color: grey.A900
        //     }
        // },
        MuiInputBase: {
            input: {
            }
        },
        MuiButton: {
            root: {
                // color: grey.A900
            }
        },
        MuiFormControl: {
            root: {
                // color: grey.A900
            }
        },
        MuiToggleButton: {
            root: {
                color: basic.palette.text.primary,
                borderColor: basic.palette.primary.dark,
                '&$selected': {
                    color: basic.palette.primary.contrastText,
                    backgroundColor: basic.palette.primary.main,
                    '&:hover': {
                        backgroundColor: basic.palette.primary.dark
                    }
                }
            },
            sizeSmall: {
                fontSize: basic.typography.button.fontSize
            }
        },
        MuiSelect: {
            // root: {
            //     fontSize: 16,
            //     lineHeight: 1
            // }
            // .MuiListItem-root.Mui-selected, .MuiListItem-root.Mui-selected:hover
        },
        MuiListItem: {
            root: {
                '&$selected': {
                    color: basic.palette.primary.contrastText,
                    backgroundColor: basic.palette.primary.main,
                    '&:hover': {
                        backgroundColor: basic.palette.primary.dark
                    }
                }
            }
        },
        MuiOutlinedInput: {
            root: {
                '&$focused $notchedOutline': {
                    borderColor: basic.palette.primary.dark
                },
                '&:hover $notchedOutline': {
                    borderColor: basic.palette.primary.light
                }
            },
            notchedOutline: {
                borderColor: basic.palette.primary.dark
            }
        },
        MuiTabs: {
            root: {
                borderBottom: `1px solid ${basic.palette.grey[300]}`
            }
        },
        MuiTab: {
            root: {
                minWidth: 'auto !important'
            }
        },
        MuiBottomNavigation: {
            root: {
                backgroundColor: basic.palette.grey[100]
            }

        }
    }
}));





